import { faqData, commentsData } from '@/mocks/homeData';

export default function FaqCommentsSection() {
  return (
    <>
      <section id="faq" className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜问答</h2>
            <p className="mt-2 text-sm text-foreground-500">关于吃瓜网51，你想知道的都在这里</p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq, idx) => (
              <details key={idx} className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden" open={idx === 0}>
                <summary className="flex items-center justify-between cursor-pointer p-5 md:p-6 select-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-8">{faq.question}</h3>
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-open:rotate-45 transition-transform duration-200 flex-shrink-0">
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section id="comments" className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜热评</h2>
            <p className="mt-2 text-sm text-foreground-500">百万吃瓜群众的真实声音</p>
          </div>

          <div className="space-y-4">
            {commentsData.map((comment, idx) => (
              <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img src={comment.avatar} alt={comment.nickname} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.nickname}</span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                    </div>
                    <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                    <div className="mt-3 flex items-center gap-4">
                      <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                        <i className="ri-thumb-up-line"></i>
                        <span>{comment.likes}</span>
                      </button>
                      <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                        <i className="ri-chat-1-line"></i>
                        <span>回复</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}